// Module
var code = "<cjs-smart-select ref=\"smartSelect\"></cjs-smart-select>\n<div ref=\"selectedValuesContainer\" class=\"flex-container-column overflow-auto\">\n    <cjs-smart-table ref=\"selectedValuesTable\"></cjs-smart-table>\n</div>";
// Exports
module.exports = code;